import { EngagementTeam } from "@oldDashboard/legacyModels/engagementTeam.model";
import { EngagementTeamSerializer } from "@oldDashboard/legacyModels/serializers/engagementTeamSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";
export class CommandEngagementTeam {

    async run(affiliateSelected: String, launchSelected: String, startDate: String, endDate: String, periodSelected: String) {  
        const path = `get-chart-data/client:your-engagement-team/?afiiliate_id=${affiliateSelected}&launch_id=${launchSelected}&time_period=${periodSelected}&start_date=&${startDate}&end_date=${endDate}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success) {
                const { engagement_manager, engagement_manager_email, enterprise_partnership_manager,enterprise_partnership_manager_email } = response.chart_data.data; 
                const obj = {
                        engagementManager: engagement_manager, 
                        engagementManagerEmail: engagement_manager_email, 
                        enterprisePartnershipManager: enterprise_partnership_manager, 
                        enterprisePartnershipManagerEmail: enterprise_partnership_manager_email
                    }; 
                return this.deserialize(obj);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: any) : EngagementTeam{
        const serializer = new EngagementTeamSerializer();
        return serializer.deserialize(data);
    }
}

